<app-card padding="px-5 py-3" [clickable]="true" (clicked)="login.emit()">
  <div class="capitalize flex items-center justify-center text-xl gap-4">
    <span>Login with</span>
    <img src="google-logo.png" alt="google logo" class="w-8" />
  </div>
</app-card>
